import { CIcon } from '~/icons/types'

export const ciDownhillEbike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19.21 10.613a4.307 4.307 0 0 0-.973.12l-.625-1.756-.32-.896-.49-1.376h1.261a.5.5 0 0 0 .455-.293l.402-.882a.5.5 0 1 0-.91-.414l-.268.589h-1.649a.5.5 0 0 0-.471.668l.287.805-6.325 3.958L7.716 5.72l.457.002h.001a.5.5 0 0 0 .002-1l-2.322-.007h-.001a.5.5 0 0 0-.001 1l.805.002 2.057 5.963-.678.424a4.332 4.332 0 1 0 1.057 3.173 1.314 1.314 0 0 0 1.194.773 1.327 1.327 0 0 0 1.33-1.32 1.28 1.28 0 0 0-.076-.377l5.366-4.373.391 1.097a4.304 4.304 0 1 0 1.912-.464ZM8.042 14.225h-1.51l1.226-.768a3.286 3.286 0 0 1 .284.768ZM4.79 18.286a3.336 3.336 0 1 1 2.395-5.65l-2.66 1.665a.5.5 0 0 0 .265.924H8.1a3.33 3.33 0 0 1-3.309 3.061Zm4.279-4.061h-.016a4.273 4.273 0 0 0-.45-1.296l.445-.279.377 1.092a1.32 1.32 0 0 0-.356.483Zm1.84-.648a1.291 1.291 0 0 0-.539-.16l-.452-1.311 6.334-3.963.066.183.233.654Zm8.3 4.71a3.325 3.325 0 0 1-1.573-6.261l1.103 3.094a.501.501 0 0 0 .47.332.483.483 0 0 0 .169-.03.5.5 0 0 0 .303-.638l-1.107-3.107a3.335 3.335 0 1 1 .636 6.61Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'downhill-ebike',
  type: 'thin'
}
